import React from 'react';

import { IosRouterTreeNodeSnapshot, IosRouterTreeSnapshot } from './IosRouterTree';

interface Props {
  eventText: string;
  snapshot: IosRouterTreeSnapshot;
}

export class IosRouterTreeTooltipContent extends React.Component<Props> {
  render() {
    return (
      <div className="timeline-router-tree-tooltip">
        <div className="timeline-router-tree-event">{this.props.eventText}</div>
        <div className="timeline-router-tree">
          {this.props.snapshot.rootNodes.map((node) =>
            this.routerTreeNode(node, this.props.snapshot.highlightedNodeKey, 0),
          )}
        </div>
      </div>
    );
  }

  private routerTreeNode(
    node: IosRouterTreeNodeSnapshot,
    highlightedNodeKey: string | undefined,
    depth: number,
  ): React.ReactNode {
    const highlighted = node.key === highlightedNodeKey;

    return (
      <React.Fragment key={`${node.key}-${depth}`}>
        <div
          className={[
            'timeline-router-tree-node',
            node.state === 'detaching' ? 'timeline-router-tree-node-detaching' : '',
            highlighted ? 'timeline-router-tree-node-highlighted' : '',
          ].join(' ')}
          style={{
            paddingLeft: depth * 14,
          }}
        >
          {node.children.length > 0 ? 'v' : '-'} {node.label}
        </div>
        {node.children.map((child) => this.routerTreeNode(child, highlightedNodeKey, depth + 1))}
      </React.Fragment>
    );
  }
}
